import {
  RouterProvider,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getTranslations } from "./services/translation.service";
import { setResource } from "./store/slices/translationSlice";
import routes from "./routes";
import ErrorPage from "./pages/error/ErrorPage";
import Layout from "./components/layout";
import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from "jwt-decode";
import environment from "./environment";
import { getRefreshToken } from "./helpers/getRefreshToken";
function App() {
  const { i18n } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // get data from api
  const getData = async () => {
    setIsLoading(true);
    const response = await getTranslations();
    if (response?.status === 200) {
      dispatch(setResource(response?.data?.data));
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  
  const DeviceId = localStorage.getItem("deviceId");
  const SessionId = localStorage.getItem("sessionId");

  useEffect(() => {
    if (!DeviceId) {
      let newDeviceId = uuidv4();
      localStorage.setItem("deviceId", newDeviceId);
    }
    if (!SessionId) {
      let newSessionId = uuidv4();
      localStorage.setItem("sessionId", newSessionId);
    }
  }, []);

  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: routes,
    },
  ]);

  return (
    <div dir={`${i18n.language === "ar" ? "rtl" : "ltr"}`}>
      <RouterProvider router={router} />
      <ToastContainer />
    </div>
  );
}

export default App;
